export default {
  alertList: {
    columnHeader: [
      {
        id: 'result',
        textLabel: '',
        type: 'icon',
        tabletHide: false,
        width: '5%',
      },
      {
        id: 'releaseTime',
        textLabel: '發布時間',
        type: 'text',
        tabletHide: false,
        width: '10%',
      },
      {
        id: 'alertCondition',
        textLabel: '警示狀態',
        type: 'badge',
        tabletHide: false,
        width: '5%',
      },
      {
        id: 'knockOverTime',
        textLabel: '排除時間',
        type: 'text',
        tabletHide: false,
        width: '10%',
      },
      {
        id: 'content',
        textLabel: '內容',
        type: 'text',
        tabletHide: false,
        overflowHide: true,
        width: '40%',
      },
      {
        id: 'taskCondition',
        textLabel: '任務狀態',
        type: 'badge',
        tabletHide: false,
        width: '5%',
      },
    ],
    rowData: [],
  },
  cardList: [
    {
      id: "alert",
      title: "警示",
      level: 2,
      num: 0,
    },
    {
      id: "early",
      title: "預警",
      level: 1,
      num: 0,
    },
    {
      id: "not-excluded",
      type: "percent",
      title: "未排除",
      num: 0,
      icon: "icon-nav-alert-filled",
    },
    {
      id: "excluded",
      type: "percent",
      title: "已排除",
      num: 0,
      icon: "icon-alert-cancel",
    },
  ],
  tabList: [
    {
      id: '1',
      textLabel: '未排除',
      num: 0,
    },
    {
      id: '2',
      textLabel: '已排除',
      num: 0,
    },
    {
      id: '3',
      textLabel: '全部',
      num: 0,
    },
  ],
};
